import { createFileRoute, Outlet } from "@tanstack/react-router";

import { stewardFontLinks } from "@/landing/styles/steward-fonts";
import stewardThemeCss from "@/landing/styles/steward-theme.css?url";

export const Route = createFileRoute("/_rootLayout")({
  component: RouteComponent,
  head: () => ({
    links: [{ rel: "stylesheet", href: stewardThemeCss }, ...stewardFontLinks],
  }),
});

function RouteComponent() {
  return (
    <div
      className="steward-theme flex min-h-[100dvh] w-full flex-col"
      style={{ backgroundColor: "var(--ground)", colorScheme: "light" }}
    >
      <Outlet />
    </div>
  );
}
